import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Timer, Waves, Thermometer, MapPin } from 'lucide-react';
import { Location } from '@/types/location';

interface GuestQuickActionsProps {
  location: Location;
  className?: string;
}

const GuestQuickActions: React.FC<GuestQuickActionsProps> = ({ location, className = '' }) => {
  return (
    <div className={`flex flex-col sm:flex-row gap-2 ${className}`}>
      {/* Live Dip with Countdown */}
      <Button
        asChild
        size="sm"
        variant="outline"
        className="flex items-center gap-2 border-sauna-orange text-sauna-orange hover:bg-sauna-orange hover:text-white"
      >
        <Link to={`/log-dip?location=${location.id}&mode=live`}>
          <Timer className="h-4 w-4" />
          <span className="hidden sm:inline">Live Dip</span>
          <span className="sm:hidden">Live</span>
        </Link>
      </Button>

      {/* Log Dip After Event */}
      <Button
        asChild
        size="sm"
        variant="outline"
        className="flex items-center gap-2 border-sauna-blue text-sauna-blue hover:bg-sauna-blue hover:text-white"
      >
        <Link to={`/log-dip?location=${location.id}&mode=after`}>
          <Waves className="h-4 w-4" />
          <span className="hidden sm:inline">Log After</span>
          <span className="sm:hidden">After</span>
        </Link>
      </Button>

      {/* Log Temperature Only */}
      <Button
        asChild
        size="sm"
        variant="outline"
        className="flex items-center gap-2 border-sauna-green text-sauna-green hover:bg-sauna-green hover:text-white"
      >
        <Link to={`/sauna/${location.id}#temperature`}>
          <Thermometer className="h-4 w-4" />
          <span className="hidden sm:inline">Temperature</span>
          <span className="sm:hidden">Temp</span>
        </Link>
      </Button>

      {/* View Details */}
      <Button
        asChild
        size="sm"
        variant="default"
        className="flex items-center gap-2 bg-sauna-orange hover:bg-sauna-orange/90 text-white"
      >
        <Link to={`/sauna/${location.id}`}>
          <MapPin className="h-4 w-4" />
          <span className="hidden sm:inline">Details</span>
          <span className="sm:hidden">View</span>
        </Link>
      </Button>
    </div>
  );
};

export default GuestQuickActions;
